import { CompletionStrip } from "./CompletionStrip";

import type { Completion } from "@canvaschool/contracts";

export type CompletionPanelProps = {
  /** `mode` here is the canvas's own: GROUP for a group template, INDIVIDUAL
   * for one with owner-tagged frames. It is fixed, so there is no toggle. */
  completion: Completion;
  slots: readonly number[];
  onToggle(slot: number, checked: boolean): void;
  /** Every slot is checked; the caller adds a screen-level highlight even
   * when the chime itself is muted or blocked by the browser. */
  allChecked?: boolean;
  /** Reset is a teacher action; the numbered grid stays open to everyone
   * (spec: students already check themselves off). */
  isTeacher: boolean;
  onReset(): void;
};

/**
 * Stacks a title above the numbered grid and the teacher-only reset below
 * it, in one card anchored at the right edge, vertically centered. A visible
 * card — rather than transparent floating buttons — is also the fix for the
 * buttons being unclickable in production: Excalidraw's own root establishes
 * no stacking context of its own, so a bare absolutely-positioned sibling
 * can end up painted (and hit-tested) underneath one of its internal layers.
 * `isolation: isolate` on `.canvaschool-editor-canvas` closes that gap; this
 * card's own stacking context is the belt to that suspenders.
 */
export const CompletionPanel = ({
  completion,
  slots,
  onToggle,
  allChecked = false,
  isTeacher,
  onReset,
}: CompletionPanelProps) => (
  <div
    className="canvaschool-completion-panel"
    onPointerDown={(event) => event.stopPropagation()}
  >
    <div className="canvaschool-completion-panel-title">완료표시</div>
    <CompletionStrip
      completion={completion}
      slots={slots}
      onToggle={onToggle}
      allChecked={allChecked}
    />
    {isTeacher && (
      <button
        type="button"
        className="canvaschool-completion-panel-action"
        onClick={onReset}
      >
        초기화
      </button>
    )}
  </div>
);
